export enum AppLanguage {
  Arabic = 'ar',
  English = 'en',
}

export enum TextDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}

export const LANGUAGE_DIRECTION: Record<AppLanguage, TextDirection> = {
  [AppLanguage.Arabic]: TextDirection.RTL,
  [AppLanguage.English]: TextDirection.LTR,
};
